import { ArrowRight, Sparkles } from "lucide-react";
import liquidGradient from "../assets/images/liquid-gradient.png";
import { Button } from "@mui/material";

const CTA = () => {
    return (
        <section className="py-32 relative overflow-hidden">
            {/* Background gradient */}
            <div className="absolute inset-0 opacity-30">
                <div
                    className="absolute inset-0 scale-125 animate-gradient-shift-slow"
                    style={{
                        backgroundImage: `url(${liquidGradient})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        filter: 'blur(40px)',
                    }}
                />
            </div>

            {/* Overlay */}
            <div className="absolute inset-0 bg-gradient-to-b from-background via-background/80 to-background" />

            <div className="container relative z-10 px-6">
                <div className="max-w-4xl mx-auto text-center relative">
                    {/* Glow effect */}
                    <div className="absolute inset-0 -m-20 bg-gradient-to-r from-primary/10 via-accent-foreground/10 to-primary/10 blur-3xl rounded-full" />

                    {/* Content card */}
                    <div className="relative glass-strong p-12 md:p-20 rounded-[2.5rem] border border-border/30">
                        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-8">
                            <Sparkles className="w-4 h-4 text-primary" />
                            <span className="text-sm font-medium text-primary">Join the Future</span>
                        </div>

                        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight">
                            Ready to Meet Your
                            <br />
                            <span className="gradient-text-vibrant">Favorite Creator?</span>
                        </h2>

                        <p className="text-foreground/60 text-lg md:text-xl mb-10 max-w-xl mx-auto leading-relaxed">
                            Join thousands of fans already connecting with AI twins of the world's top creators.
                        </p>

                        <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
                            <button type="button" className="theme-solid-btn">
                                Get Started Free
                                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
                            </button>
                            <button type="button" className="theme-transparent-btn">
                                Learn More
                            </button>
                        </div>

                        <p className="text-sm text-foreground/40 mt-8">
                            No credit card required • Free trial available
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CTA;
